import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT

//获取列表数据
export const sellDetail= (params) => {
  return axios.post(root + '/order/jxcglassessell/detail', qs.stringify(params));
}


export const otherformList= (params) => {
  return axios.post(root + '/files/otherform/list', qs.stringify(params));
}


export const getfunduscamera= (params) => {
  return axios.post('https://api.zyanjing.com' + '/airdoc/checkLog', qs.stringify(params));
}


export const getAirdocReport= (params) => {
  return axios.post('https://api.zyanjing.com' + '/airdoc/getReport', qs.stringify(params));
}



// WEBPACK FOOTER //
// ./src/api/order/jxcglassesell.js